// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x-submenu[data-v-e6ad9308]{background:#f3f6f8;border-bottom:1px solid #e0e6e8;border-top:1px solid transparent;height:3rem;overflow:visible;position:relative}.dundle .x-submenu[data-v-e6ad9308]{border-top:1px solid #e0e6e8}.dundle .is-scrolling .x-submenu[data-v-e6ad9308]{border-bottom:1px solid #d7dfe1}.x-submenu[data-v-e6ad9308]:after{clear:both;content:\"\";display:block}.x-submenu[data-v-e6ad9308]::-webkit-scrollbar{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
